var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"toast-pack",on:{"mouseover":_vm.handleMouseOver,"mouseleave":function($event){_vm.toggle = false}}},[_c('div',{staticClass:"toast-pack__label"},[_vm._t("default")],2),(_vm.toggle)?_c('div',{staticClass:"toast-pack__content"},[_vm._t("content")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }